import { AlertCircle, RefreshCw } from 'lucide-react';

interface ConfigurationErrorProps {
  message: string;
  details?: string;
  onRetry?: () => void;
}

export function ConfigurationError({ message, details, onRetry }: ConfigurationErrorProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mx-auto mb-4">
          <AlertCircle className="w-8 h-8 text-yellow-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
          Configuration Required
        </h1>
        
        <p className="text-gray-600 text-center mb-6">
          {message}
        </p>
        
        {details && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700 font-mono">
              {details}
            </p>
          </div>
        )}
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-blue-900 mb-2">Configuration Options:</h3>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• URL Parameters: <code className="bg-blue-100 px-1 rounded">?jwt=xxx&supabaseUrl=xxx</code></li>
            <li>• Global Config: <code className="bg-blue-100 px-1 rounded">window.EDI_CONFIG</code></li>
            <li>• Component Attributes: <code className="bg-blue-100 px-1 rounded">supabase-url, jwt-token</code></li>
          </ul>
        </div>
        
        <div className="text-center">
          {onRetry && (
            <button
              onClick={onRetry}
              className="inline-flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <RefreshCw className="w-4 h-4" />
              Retry
            </button>
          )}
          
          <p className="text-sm text-gray-500 mt-4">
            Contact your administrator for access credentials.
          </p>
        </div>
      </div>
    </div>
  );
}
